import { JSONSchema7 } from 'json-schema';
import { types as commonTypes, customSchemas } from '@sitebuilder/common';
import TextWrapper from './TextWrapper';

const {
    schema: generatedSchema,
    uiSchema: generatedUiSchema,
    group: generatedGroup,
    dependencies: generatedDependencies,
} = customSchemas.GenerateAnalyticsSchema(['Click']);

const schema: JSONSchema7 = {
    title: 'Text',
    type: 'object',
    required: [],
    properties: {
        styles: {
            type: 'string',
            description: 'Add styling',
            default: '',
        },
        ...customSchemas.textSchema.TextSchema.schema,
        ...customSchemas.styleSchema.StyleSchema.schema,
        ...customSchemas.layoutSchema.LayoutSchema.schema,
        ...generatedSchema,
        textInput: {
            type: 'string',
            description: 'Enter text here',
            default: '',
            title: 'Text',
        },
        truncateTextAt: {
            type: 'number',
            description: 'Enter character count to truncate text and show red more',
            title: 'Enable Read more at',
        },
        readMoreText: {
            type: 'string',
            description: 'Enter text to show as read more',
            default: '',
            title: 'Read more text',
        },
        readLessText: {
            type: 'string',
            description: 'Enter text to show as read less',
            default: '',
            title: 'Read less text',
        },
        isTransformData: {
            type: 'boolean',
            title: 'Transform Data',
            default: false,
        },
        disableTabStaticData: {
            type: 'boolean',
            title: 'Disable tabbing through static data',
            description: '',
        },
    },
    dependencies: {
        isTransformData: {
            oneOf: [
                {
                    properties: {
                        isTransformData: { enum: [true] },
                        functionToTransform: {
                            type: 'string',
                            description: 'Function to transform',
                            default:
                                // eslint-disable-next-line max-len
                                'return (data) => { return { text } }',
                        },
                    },
                },
                {
                    properties: {
                        isTransformData: { enum: [false] },
                    },
                },
            ],
        },
        ...generatedDependencies,
        ...customSchemas.layoutSchema.LayoutSchema.dependencies,
    },
};

const groups = [
    {
        'Style Editor': ['styles'],
        ...customSchemas.textSchema.TextSchema.group,
        ...customSchemas.styleSchema.StyleSchema.group,
        ...customSchemas.layoutSchema.LayoutSchema.group,
        Values: ['textInput', 'truncateTextAt', 'readMoreText', 'readLessText'],
        ...generatedGroup,
        'Transform Data': ['isTransformData', 'functionToTransform'],
        Accessibility: ['disableTabStaticData'],
    },
];

const TextWidget: commonTypes.IWidget = {
    schema,
    uiSchema: {
        'ui:groups': groups,
        ...customSchemas.textSchema.TextSchema.uiSchema,
        ...customSchemas.styleSchema.StyleSchema.uiSchema,
        ...customSchemas.layoutSchema.LayoutSchema.uiSchema,
        ...generatedUiSchema,
        textInput: {
            'ui:widget': 'ResourcePicker',
        },
        truncateTextAt: { 'ui:widget': 'CustomTextInput' },
        readMoreText: {
            'ui:widget': 'ResourcePicker',
        },
        readLessText: {
            'ui:widget': 'ResourcePicker',
        },
        isTransformData: { 'ui:widget': 'CustomCheckbox' },
        styles: {
            'ui:widget': 'CSSEditor',
        },
        functionToTransform: { 'ui:widget': 'JSEditor' },
        disableTabStaticData: { 'ui:widget': 'CustomCheckbox' },
    },
    templateView: TextWrapper,
    id: 'Text',
    group: 'component',
    contentPlaceHolders: ['children'],
    initialData: (_context?: Record<string, unknown>) => ({}),
};

export default TextWidget;
